import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'login',
    component: () => import('../views/login.vue')
  },
  {
    path: '/home',
    name: 'home',
    component: () => import('../views/home.vue'),
    children: [
      { path: '/dashboard', name: 'dashboard', component: () => import('../views/dashboard.vue') },
      { path: '/apps', name: 'apps', component: () => import('../views/apps.vue') },
      { path: '/updateVendor', name: 'updateVendor', component: () => import('../views/editableViews/addOrEditVendor') },,
      { path: '/vendorDetails', name: 'vendorDetails', component: () => import('../views/editableViews/vendorDetails') },
      {path: '/apikey', name:'apiKey', component: ()=> import('../views/apiKey/apikey') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})



export default router
